<template>
  <div class="flex flex-col rounded-[15px]  p-4 ring-1 ring-gray-light md:p-6" :class="disabled ? 'bg-gray-light text-gray-dark' : 'bg-white'">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Box',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
